window.theme = window.theme || {};

window.addEventListener('DOMContentLoaded', () => {
  theme.SizingCharts = (function () {

    var selectors = {
      unitButtonSingle: '.js-unit-button',
      cmActive: 'cm-active',
      inActive: 'in-active'
    };

    function init() {

      $(selectors.unitButtonSingle).on('click', switchUnit);

      function switchUnit() {

        if ($(this).attr("aria-checked") == "true") {
          $(this).attr("aria-checked", "false");
        } else {
          $(this).attr("aria-checked", "true");
        }

        const active = $(this).data('active')
        if (active === 'cm') {
          $(this).data('active', 'in')
          $(this).removeClass(selectors.cmActive)
          $(this).addClass(selectors.inActive)
          $(this).parents('.js-unit-table-wrap').find('.js-unit-table-container').removeClass(selectors.cmActive)
          $(this).parents('.js-unit-table-wrap').find('.js-unit-table-container').addClass(selectors.inActive)
        } else {
          $(this).data('active', 'cm')
          $(this).removeClass(selectors.inActive)
          $(this).addClass(selectors.cmActive)
          $(this).parents('.js-unit-table-wrap').find('.js-unit-table-container').removeClass(selectors.inActive)
          $(this).parents('.js-unit-table-wrap').find('.js-unit-table-container').addClass(selectors.cmActive)
        }
      }
    }

    function defer(method) {
      if (window.jQuery) {
          method();
      } else {
          setTimeout(function() { defer(method) }, 50);
      }
    }

    return defer(init);
  })();
});
